var map = {
	"./1.jpg": 3484,
	"./2.jpg": 2987,
	"./3.jpg": 652,
	"./4.jpg": 93,
	"./5.jpg": 5687,
	"./6.jpg": 5862,
	"./7.jpg": 4947
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2170;